export default "__VITE_ASSET__3b2ddac0__"